import "./NabiStore.css";
import React, { useState, useEffect, useRef } from "react";
import { useOutletContext, useNavigate } from "react-router-dom";
import { processPayment } from "./paymentstore";
import axios from "axios";
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
// IMPORT AUTH TO GET USER ID
import { db, collection, addDoc, serverTimestamp, auth } from "./firebase";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

const DefaultIcon = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconAnchor: [12, 41]
});
L.Marker.prototype.options.icon = DefaultIcon;

// const SHIPROCKET_API_URL = "https://createshiprocketorder-qxb2xs4n7a-uc.a.run.app";
const SHIPROCKET_API_URL = "https://createshiprocketorder-qxb2xs4n7a-uc.a.run.app";

// --- ASSETS & DATA ---
const ASSETS = {
  hero: "/Nabi UI Assets/Assets_Images/Nabi_Store.png",
  icons: {
    search: "/Nabi UI Assets/Assets_Icon/Icon_Search.svg" // Search Icon
  },
  placeholders: {
    tote: "/Nabi UI Assets/Assets_Images/Image_Video placeholder.png",
    journal: "/Nabi UI Assets/Assets_Images/Image_Video placeholder.png",
    bookmark: "/Nabi UI Assets/Assets_Images/Image_Video placeholder.png"
  }
};

export const PRODUCTS = [
  // 👜 TOTE BAGS
  {
    id: 1,
    name: "\"Be You\" Tote Bag",
    price: 350,
    category: "apparel",
    image: "/Tote Bags/be you.jpg",
    status: "In stock",
    description: "Carry a little truth with you. The Be You tote is your daily reminder to move with honesty and heart."
  },
  {
    id: 2,
    name: "\"Be Radiant\" Tote Bag",
    price: 350,
    category: "apparel",
    image: "/Tote Bags/be radiant.JPG",
    status: "In stock",
    description: "Shine bright and carry your light everywhere."
  },
  {
    id: 3,
    name: "\"Be Wise\" Tote Bag",
    price: 350,
    category: "apparel",
    image: "/Tote Bags/be wise.JPG",
    status: "In stock",
    description: "Wisdom, wrapped in simplicity."
  },
  {
    id: 4,
    name: "\"Be Playful\" Tote Bag",
    price: 350,
    category: "apparel",
    image: "/Tote Bags/be playful.JPG",
    status: "In stock",
    description: "For days that call for fun and lightness."
  },
  {
    id: 5,
    name: "\"Be at Peace\" Tote Bag",
    price: 350,
    category: "apparel",
    image: "/Tote Bags/be at peace.jpg",
    status: "In stock",
    description: "Carry calm wherever you go."
  },
  {
    id: 6,
    name: "\"Be Calm\" Tote Bag",
    price: 350,
    category: "apparel",
    image: "/Tote Bags/be calm.JPG",
    status: "In stock",
    description: "Soft reminders for peaceful days."
  },

  // 🔖 BOOKMARKS
  {
    id: 7,
    name: "\"Be Hopeful\" Bookmark",
    price: 25,
    category: "bookmarks",
    image: "/Bookmarks/Be Hopeful.JPG",
    status: "In stock",
    description: "A gentle reminder to stay hopeful."
  },
  {
    id: 8,
    name: "\"Be Patient\" Bookmark",
    price: 25,
    category: "bookmarks",
    image: "/Bookmarks/Be Patient.JPG",
    status: "In stock",
    description: "Slow down, your page will wait."
  },
  {
    id: 9,
    name: "\"Be Resilient\" Bookmark",
    price: 25,
    category: "bookmarks",
    image: "/Bookmarks/Be Resilient.JPG",
    status: "In stock",
    description: "Strength between the pages."
  },
  {
    id: 10,
    name: "\"Dawn & Dusk\" Bookmark",
    price: 25,
    category: "bookmarks",
    image: "/Bookmarks/Dusk_Dawn.JPG",
    status: "In stock",
    description: "For both morning and evening reads."
  },
  {
    id: 11,
    name: "\"Morning\" Bookmark",
    price: 25,
    category: "bookmarks",
    image: "/Bookmarks/Morning.JPG",
    status: "In stock",
    description: "Fresh starts for early readers."
  },
  {
    id: 12,
    name: "\"Night\" Bookmark",
    price: 25,
    category: "bookmarks",
    image: "/Bookmarks/Night.JPG",
    status: "In stock",
    description: "Perfect for midnight stories."
  },

  // 📓 JOURNALS
  {
    id: 13,
    name: "\"Spring\" Journal",
    price: 300,
    category: "journaling",
    image: "/Journals/Spring.png",
    images: ["/Journals/Spring.png", "/Journals/Spring_Additional.png"],
    status: "In stock",
    description: "Fresh beginnings and blooming thoughts."
  },
  {
    id: 14,
    name: "\"Summer\" Journal",
    price: 300,
    category: "journaling",
    image: "/Journals/Summer.png",
    images: ["/Journals/Summer.png", "/Journals/Summer_Additional.png"],
    status: "In stock",
    description: "Capture warm memories and bright days."
  },
  {
    id: 15,
    name: "\"Autumn\" Journal",
    price: 300,
    category: "journaling",
    image: "/Journals/Autumn.png",
    images: ["/Journals/Autumn.png", "/Journals/Autumn_Additional.png"],
    status: "In stock",
    description: "Thoughtful pages for slowing down."
  },
  {
    id: 16,
    name: "\"Winter\" Journal",
    price: 300,
    category: "journaling",
    image: "/Journals/Winter.png",
    images: ["/Journals/Winter.png", "/Journals/Winter_Additional.png"],
    status: "In stock",
    description: "Quiet moments, captured softly."
  },

];


const SWIPE_THRESHOLD = 50;

// --- COMPONENT: PRODUCT DETAIL ---
const ProductDetail = ({ product, onBack, onAddToCart }) => {
  const [qty, setQty] = useState(1);
  const [imageIndex, setImageIndex] = useState(0);
  const touchStartX = useRef(0);
  const images = product.images && product.images.length > 0 ? product.images : [product.image];

  const handlePrevImage = () => {
    setImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNextImage = () => {
    setImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
  };

  const onTouchEnd = (e) => {
    if (images.length <= 1) return;
    const endX = e.changedTouches[0].clientX;
    const delta = touchStartX.current - endX;
    if (delta > SWIPE_THRESHOLD) handleNextImage();
    else if (delta < -SWIPE_THRESHOLD) handlePrevImage();
  };

  return (
    <div className="ns-pageContainer">
      <div className="ns-backButton" onClick={onBack}>
        <span className="ns-backButton-icon">←</span> Back to Store
      </div>
      <div className="ns-detailLayout">
        <div
          className="ns-detailLayout-left"
          onTouchStart={onTouchStart}
          onTouchEnd={onTouchEnd}
        >
          <img
            src={images[imageIndex]}
            alt={product.name}
            style={{ width: '100%', borderRadius: '20px' }}
            onError={(e) => {
              // Fallback to primary image if an alternate fails to load
              e.target.onerror = null;
              e.target.src = product.image;
            }}
          />
          {images.length > 1 && (
            <>
              <button onClick={handlePrevImage} className="ns-imageNavBtn" style={{ left: '10px' }}>‹</button>
              <button onClick={handleNextImage} className="ns-imageNavBtn" style={{ right: '10px' }}>›</button>
              <div className="ns-imageIndicator">
                {imageIndex + 1} / {images.length}
              </div>
            </>
          )}
        </div>
        <div className="ns-detailLayout-right">
          <h1 style={{ fontSize: '2.5rem', marginBottom: '10px', color: '#003049', fontWeight: "normal" }}>{product.name}</h1>
          <h2 style={{ fontSize: '1.5rem', fontWeight: 'normal', marginBottom: '30px' }}>₹{product.price.toFixed(2)}</h2>
          <p style={{ fontSize: '12px', fontWeight: 'bold', marginBottom: '10px' }}>Quantity *</p>
          <div className="ns-qtyControl">
            <button onClick={() => setQty(Math.max(1, qty - 1))}>-</button>
            <span style={{ margin: '0 20px' }}>{qty}</span>
            <button onClick={() => setQty(qty + 1)}>+</button>
          </div>
          <button className="ns-addToCartBtn" onClick={() => onAddToCart(product, qty)}>Add to Cart</button>
          <p style={{ marginTop: '40px', lineHeight: '1.6', color: '#555' }}>{product.description}</p>
        </div>
      </div>
    </div>
  );
};

// --- COMPONENT: LOCATION PICKER MODAL (Swiggy Style) ---
const MapEventsHandler = ({ setAddressPreview, setDetailedAddress, centerCoords }) => {
  const map = useMapEvents({
      moveend: async () => {
          const center = map.getCenter();
          setAddressPreview("Fetching exact location address...");
          try {
              const res = await axios.get(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${center.lat}&lon=${center.lng}`);
              if (res.data && res.data.address) {
                  setAddressPreview(res.data.display_name);
                  const addr = res.data.address;
                  setDetailedAddress({
                      address: res.data.display_name || "",
                      city: addr.city || addr.town || addr.village || "",
                      state: addr.state || "",
                      pincode: (addr.postcode || "").replace(/\D/g, '').slice(0, 6)
                  });
              }
          } catch (err) {
              setAddressPreview("Failed to fetch address. Try moving the map slightly.");
          }
      }
  });
  
  // When centerCoords changes from outside (e.g. GPS button), fly to it
  useEffect(() => {
      if (centerCoords) {
          map.flyTo(centerCoords, 15);
      }
  }, [centerCoords, map]);

  return null;
}

const LocationPickerModal = ({ isOpen, onClose, initialPincode, initialArea, onLocationSelected }) => {
  const [addressPreview, setAddressPreview] = useState("Move map to select location...");
  const [centerCoords, setCenterCoords] = useState(null);
  const [isLocating, setIsLocating] = useState(false);
  const [detailedAddress, setDetailedAddress] = useState(null);

  useEffect(() => {
    if (isOpen) {
       if (initialPincode && typeof initialPincode === 'object' && initialPincode.lat) {
           // We got passed exact coords from the dropdown!
           setCenterCoords([initialPincode.lat, initialPincode.lon]);
       } else if (initialArea && initialPincode) {
           const querySpecific = `${initialArea}, ${initialPincode}, India`;
           const queryPincode = `${initialPincode}, India`;
           
           axios.get(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(querySpecific)}&format=json`)
             .then(res => {
                 if (res.data && res.data.length > 0) {
                     setCenterCoords([parseFloat(res.data[0].lat), parseFloat(res.data[0].lon)]);
                 } else {
                     return axios.get(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(queryPincode)}&format=json`);
                 }
             })
             .then(res => {
                 if (res && res.data && res.data.length > 0) {
                     setCenterCoords([parseFloat(res.data[0].lat), parseFloat(res.data[0].lon)]);
                 } else if (res) {
                     setCenterCoords([20.5937, 78.9629]); // fallback
                 }
             }).catch(() => setCenterCoords([20.5937, 78.9629]));
       } else if (typeof initialPincode === 'string' && initialPincode.length === 6) {
           const queryPincode = `${initialPincode}, India`;
           axios.get(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(queryPincode)}&format=json`)
             .then(res => {
                 if (res.data && res.data.length > 0) {
                     setCenterCoords([parseFloat(res.data[0].lat), parseFloat(res.data[0].lon)]);
                 } else {
                     setCenterCoords([20.5937, 78.9629]); // fallback
                 }
             }).catch(() => setCenterCoords([20.5937, 78.9629]));
       } else {
           setCenterCoords([20.5937, 78.9629]); // Default to India center
       }
    }
  }, [isOpen, initialPincode, initialArea]);

  const handleUseCurrentLocation = () => {
      setIsLocating(true);
      navigator.geolocation.getCurrentPosition((pos) => {
          setCenterCoords([pos.coords.latitude, pos.coords.longitude]);
          setIsLocating(false);
      }, () => {
          alert("Could not get location. Please enable location permissions in your browser.");
          setIsLocating(false);
      });
  };

  if (!isOpen || !centerCoords) return null;

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
       <div style={{ width: '90%', maxWidth: '500px', backgroundColor: 'white', borderRadius: '12px', overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 10px 30px rgba(0,0,0,0.3)' }}>
          <div style={{ padding: '15px 20px', display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', backgroundColor: '#fdfdfd' }}>
             <h3 style={{ margin: 0, fontSize: '1.2rem', color: '#003049' }}>Select Delivery Location</h3>
             <button onClick={onClose} style={{ border: 'none', background: 'none', fontSize: '20px', cursor: 'pointer', color: '#888' }}>✖</button>
          </div>
          
          <div style={{ position: 'relative', height: '350px', width: '100%' }}>
             <MapContainer center={centerCoords} zoom={15} style={{ height: '100%', width: '100%' }} zoomControl={false}>
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <MapEventsHandler 
                   setAddressPreview={setAddressPreview} 
                   setDetailedAddress={setDetailedAddress} 
                   centerCoords={centerCoords} 
                />
             </MapContainer>
             {/* Center fixed pin */}
             <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -100%)', zIndex: 1000, pointerEvents: 'none' }}>
                <img src="https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png" alt="pin" style={{ width: '35px', filter: 'drop-shadow(0px 2px 2px rgba(0,0,0,0.4))' }} />
             </div>
             {/* Use Current Location Button */}
             <button onClick={handleUseCurrentLocation} style={{ position: 'absolute', bottom: '20px', right: '20px', zIndex: 1000, padding: '10px 15px', backgroundColor: 'white', color: '#003049', fontWeight: 'bold', border: 'none', borderRadius: '8px', boxShadow: '0 2px 6px rgba(0,0,0,0.2)', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '16px' }}>🎯</span> {isLocating ? "Locating..." : "Use Current Location"}
             </button>
          </div>
          
          <div style={{ padding: '20px', display: 'flex', flexDirection: 'column', gap: '15px' }}>
             <div style={{ padding: '12px', backgroundColor: '#f5f7f9', borderRadius: '8px', fontSize: '0.9rem', color: '#555', minHeight: '45px', border: '1px solid #e1e5eb' }}>
                <strong style={{ display: 'block', marginBottom: '5px', color: '#333' }}>Location</strong>
                {addressPreview}
             </div>
             <button 
                style={{ width: '100%', padding: '14px', backgroundColor: '#003049', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '1.05rem', fontWeight: 'bold', opacity: detailedAddress ? 1 : 0.6 }}
                disabled={!detailedAddress}
                onClick={() => {
                    if (detailedAddress) {
                        onLocationSelected(detailedAddress);
                        onClose();
                    }
                }}
             >
                Confirm Location
             </button>
          </div>
       </div>
    </div>
  );
};

// --- COMPONENT: CHECKOUT VIEW ---
const CheckoutView = ({ globalCart, updateQty, removeFromCart, processPayment, onBack, initialPincode }) => {
  const cartTotal = globalCart.reduce((acc, item) => acc + (item.price * item.qty), 0);
  const [isProcessing, setIsProcessing] = useState(false);
  const [shippingCost, setShippingCost] = useState(0);
  const [selectedCourierId, setSelectedCourierId] = useState(null);
  const [selectedCourierName, setSelectedCourierName] = useState("");
  const [isCalculatingShipping, setIsCalculatingShipping] = useState(false);
  const [isDeliveryExpanded, setIsDeliveryExpanded] = useState(false);
  const [isMapOpen, setIsMapOpen] = useState(false);

  // Shipping Form State
  const [formData, setFormData] = useState({
    name: "", email: "", phone: "",
    address: "", city: "", state: "", pincode: initialPincode || ""
  });

  // Automatically recalculate shipping based on the full cart weight
  // whenever items or quantities change in the cart or when component mounts with an initial pincode.
  useEffect(() => {
    if (formData.pincode && formData.pincode.length === 6) {
      calculateShippingCost(formData.pincode);
    }
  }, [globalCart, formData.pincode]);

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    
    // Restrict phone to numeric
    if (name === 'phone') {
        value = value.replace(/\D/g, '').slice(0, 10);
    }
    // Restrict pincode to numeric
    if (name === 'pincode') {
        value = value.replace(/\D/g, '').slice(0, 6);
    }

    setFormData((prev) => ({ ...prev, [name]: value }));

    // Check if pincode is 6 digits to calculate shipping
    if (name === "pincode" && value.length === 6) {
      calculateShippingCost(value);
    } else if (name === "pincode" && value.length !== 6) {
        setShippingCost(0);
        setSelectedCourierId(null);
        setSelectedCourierName("");
    }
  };

  const calculateShippingCost = async (pincode) => {
    setIsCalculatingShipping(true);
    try {
        console.log(`[SHIPPING] Starting calculation for pincode: ${pincode}`);
        
        // 1. Calculate Weight dynamically based on minimal item weights to keep shipping costs low
        let totalWeight = globalCart.reduce((acc, item) => {
            // Minimal weights in kg: Tote 10g, Journal 10g, Bookmark 5g
            const w = item.category === 'apparel' ? 0.01 : (item.category === 'journaling' ? 0.01 : 0.005);
            console.log(`[SHIPPING] Item: ${item.name} | Qty: ${item.qty} | Category: ${item.category} | Weight assigned: ${w}kg`);
            return acc + (item.qty * w);
        }, 0);
        
        // Ensure minimum weight is 0.5kg for Shiprocket base rate
        totalWeight = Math.max(0.5, totalWeight);
        
        console.log(`[SHIPPING] Total calculated weight: ${totalWeight}kg`);
        console.log(`[SHIPPING] Calling backend API /calculateShipping...`);
        
        const response = await fetch('https://us-central1-nabi-1708b.cloudfunctions.net/calculateShipping', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 
                delivery_postcode: pincode,
                weight: totalWeight
            })
        });
        const data = await response.json();
        console.log(`[SHIPPING] Backend response:`, data);
        
        if (data.success && data.shippingCost !== undefined) {
            console.log(`[SHIPPING] Final Shipping Cost applied: ₹${data.shippingCost} (Courier: ${data.courierName} | ID: ${data.courierId})`);
            setShippingCost(data.shippingCost);
            setSelectedCourierId(data.courierId);
            setSelectedCourierName(data.courierName);
        } else {
            console.error("Shipping calc error:", data.error);
            setShippingCost(0);
        }
    } catch (err) {
        console.error("Failed to fetch shipping cost:", err);
        setShippingCost(0);
        setSelectedCourierName("");
    } finally {
        setIsCalculatingShipping(false);
    }
  };

  const handleCheckout = async () => {
    // 0. Validate Cart
    if (globalCart.length === 0) {
      alert("Your cart is empty. Please add items to your cart before proceeding to payment.");
      if (onBack) onBack();
      return;
    }

    // 1. Validate Form (Mandatory Fields)
    if (!formData.name || !formData.email || !formData.phone || !formData.address || !formData.city || !formData.state || !formData.pincode) {
      alert("Please fill in all Shipping Details (Name, Email, Phone, Address, City, State, Pincode).");
      return;
    }

    // Email Validation
    if (!formData.email.includes("@")) {
      alert("Please enter a valid email address.");
      return;
    }

    // Phone Validation
    let cleanPhone = formData.phone.replace(/\D/g, '');

    // Remove a leading '0' if the user typed one
    if (cleanPhone.startsWith('0')) {
      cleanPhone = cleanPhone.substring(1);
    }
    // Remove '91' country code if the user included it
    if (cleanPhone.startsWith('91') && cleanPhone.length === 12) {
      cleanPhone = cleanPhone.substring(2);
    }

    // Enforce exactly 10 digits for Shiprocket
    if (cleanPhone.length !== 10) {
      alert("Please enter a valid 10-digit mobile number (without 0 or +91 at the start).");
      return;
    }

    setIsProcessing(true);

    const backendOrderId = `ORD_${Date.now()}`;

    try {
        const finalTotal = cartTotal + shippingCost;
        const response = await fetch('https://us-central1-nabi-1708b.cloudfunctions.net/createRazorpayOrder', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ amount: finalTotal, bookingId: backendOrderId, type: 'store' })
        });
        const data = await response.json();
        
        if (!data.success) {
            throw new Error(data.error || "Failed to create Razorpay Order");
        }

        // 2. Process Payment
        processPayment({
          price: finalTotal,
          orderId: data.order_id,
          userData: {
        fullName: formData.name,
        email: formData.email,
        contactNumber: formData.phone
      },

      onSuccess: async (res) => {
        const paymentId = res.razorpay_payment_id;
        const orderId = backendOrderId;

        // --- GET USER ID FROM FIREBASE AUTH ---
        const userId = auth.currentUser ? auth.currentUser.uid : "guest";

        // Shiprocket processing is now handled automatically by Cloud Functions
        // when the order is saved with "Processing" status.

        try {
          // Save order to Firebase
          await addDoc(collection(db, "orders"), {
            orderId: orderId,
            userId: userId,
            paymentId: paymentId,
            items: globalCart,
            totalAmount: finalTotal, // includes shipping
            subTotal: cartTotal,
            shippingCost: shippingCost,
            courierId: selectedCourierId,
            customer: formData,
            shipmentStatus: "Processing", // Triggers Cloud Function
            createdAt: serverTimestamp(),
          });

          alert(
            `Order Placed Successfully! 
Order ID: ${orderId} 
Your shipment is being processed automatically.`
          );
        } catch (error) {
          console.error("Order processing error:", error);
          alert(
            "Payment successful, but there was an error saving the order."
          );
        } finally {
          setIsProcessing(false);
        }
      },

      onFailure: (error) => {
        alert("❌ Payment Failed or Cancelled. If the amount was deducted, please contact support with your email ID.");
        setIsProcessing(false);
        
        // Log failure to audit
        try {
          addDoc(collection(db, "payment_audit"), {
            userId: auth.currentUser ? auth.currentUser.uid : "guest",
            userEmail: formData.email,
            action: "STORE_PAYMENT_FAILED",
            amount: finalTotal,
            status: "failed",
            error: error || "Payment modal dismissed or failed",
            items: globalCart.map(item => ({ id: item.id, name: item.name, qty: item.qty })),
            timestamp: serverTimestamp()
          });
        } catch (auditError) {
          console.error("Failed to log store payment failure:", auditError);
        }
      }
    });
    } catch (err) {
        console.error("Checkout initiation error:", err);
        alert("Could not initiate checkout. Please try again.");
        setIsProcessing(false);
    }
  };

  return (
    <div className="ns-pageContainer">
      <div className="ns-backButton" onClick={() => { if(onBack) onBack(); }}>
        <span className="ns-backButton-icon">←</span> Back to Store
      </div>
      <div className="ns-checkoutLayout">
        {/* LEFT SIDE: CART & FORM */}
        <div className="ns-checkoutLayout-left">
          <h2 style={{ fontSize: '1.5rem', margin: '0 0 20px 0', fontWeight: "normal" }}>My cart</h2>
          <hr className="ns-divider" />

          {globalCart.map(item => (
            <div key={item.id} className="ns-checkoutItemRow">
              <img src={item.image} alt="" style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '8px' }} />
              <div style={{ flex: 1, paddingLeft: '20px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                  <h4 style={{ margin: 0, fontSize: '1.1rem', fontWeight: "normal" }}>{item.name}</h4>
                  <div style={{ display: 'flex', gap: '20px', alignItems: 'center', }}>
                    <div className="ns-qtyControlSm">
                      <button onClick={() => updateQty(item.id, -1)}>-</button>
                      <span>{item.qty}</span>
                      <button onClick={() => updateQty(item.id, 1)}>+</button>
                    </div>
                    <span style={{ fontWeight: 'normal' }}>₹{item.price.toFixed(2)}</span>
                    <button onClick={() => removeFromCart(item.id)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', color: '#888' }}>🗑</button>
                  </div>
                </div>
                <div style={{ fontSize: '0.9rem', color: '#555' }}>₹{item.price.toFixed(2)}</div>
              </div>
            </div>
          ))}

          {globalCart.length === 0 && <p style={{ color: '#777' }}>Your cart is empty.</p>}

          <hr className="ns-divider" />

          {/* --- SHIPPING ADDRESS FORM --- */}
          <h3 style={{ fontSize: '1.2rem', margin: '20px 0', fontWeight: "normal", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            Shipping Address
            <button onClick={() => setIsMapOpen(true)} style={{ padding: '8px 16px', backgroundColor: '#003049', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '5px' }}>
              📍 Auto-fill Location
            </button>
          </h3>
          <LocationPickerModal 
            isOpen={isMapOpen} 
            onClose={() => setIsMapOpen(false)} 
            initialPincode={formData.pincode}
            onLocationSelected={(loc) => {
              setFormData((prev) => ({
                ...prev,
                address: loc.address,
                city: loc.city,
                state: loc.state,
                pincode: loc.pincode
              }));
              if (loc.pincode && loc.pincode.length === 6) calculateShippingCost(loc.pincode);
            }} 
          />
          <div className="ns-formGrid">
            <input className="ns-input" name="name" value={formData.name} placeholder="Full Name *" onChange={handleInputChange} />
            <input className="ns-input" name="email" value={formData.email} placeholder="Email *" onChange={handleInputChange} />
            <input className="ns-input" name="phone" value={formData.phone} placeholder="Phone (10 digits) *" onChange={handleInputChange} maxLength={10} />
            <input className="ns-input" name="pincode" value={formData.pincode} placeholder="Pincode (6 digits) *" onChange={handleInputChange} maxLength={6} />
            <input className="ns-input ns-input-full" name="address" value={formData.address} placeholder="Full Address *" onChange={handleInputChange} />
            <input className="ns-input" name="city" value={formData.city} placeholder="City *" onChange={handleInputChange} />
            <input className="ns-input" name="state" value={formData.state} placeholder="State *" onChange={handleInputChange} />
          </div>

          {/* <div className="ns-actionRow">
            <span style={{ fontSize: '1.2rem' }}>🏷️</span>
            <span className="ns-actionText">Enter a promo code</span>
          </div> */}
        </div>

        {/* RIGHT SIDE: ORDER SUMMARY */}
        <div className="ns-checkoutLayout-right">
          <div className="ns-orderSummaryCard">
            <h3 className="ns-summaryTitle">Order summary</h3>
            <hr className="ns-divider" />
            <div className="ns-summaryRow"><span>Subtotal</span><span>₹{cartTotal.toFixed(2)}</span></div>
            
            <div 
              className="ns-summaryRow" style={{ cursor: 'pointer', userSelect: 'none', marginBottom: isDeliveryExpanded ? '5px' : '12px' }}
              onClick={() => setIsDeliveryExpanded(!isDeliveryExpanded)}
            >
              <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                Delivery {isDeliveryExpanded ? <UpOutlined style={{ fontSize: '10px' }} /> : <DownOutlined style={{ fontSize: '10px' }} />}
              </span>
              <span style={{ fontSize: '0.85rem', color: '#888' }}>{isDeliveryExpanded ? "" : ""}</span>
            </div>
            
            {isDeliveryExpanded && (
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '12px', paddingLeft: '15px', fontSize: '0.9rem', color: '#555', transition: 'all 0.3s ease' }}>
                <span>{selectedCourierName ? `Courier (${selectedCourierName})` : 'Standard Delivery'}</span>
                <span>{isCalculatingShipping ? "Calculating..." : (shippingCost > 0 ? `₹${shippingCost.toFixed(2)}` : (formData.pincode.length === 6 ? "Free" : "Enter Pincode"))}</span>
              </div>
            )}

            <hr className="ns-divider" />
            <div className="ns-totalRow"><span>Total</span><span>₹{(cartTotal + shippingCost).toFixed(2)}</span></div>

            <button
              className="ns-checkoutBtn" style={{ opacity: isProcessing ? 0.7 : 1 }}
              onClick={handleCheckout}
              disabled={isProcessing}
            >
              {isProcessing ? "Processing..." : "Pay & Ship"}
            </button>
            <div className="ns-secureText"><span>🔒 Secure Checkout</span></div>
            
            <div 
              onClick={() => { if(onBack) onBack(); }}
              style={{ textAlign: 'center', marginTop: '25px', fontSize: '0.9rem', color: '#003049', cursor: 'pointer', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', transition: 'opacity 0.2s' }}
              onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
              onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
            >
              <span>🎁</span>
              <span style={{ textDecoration: 'underline' }}>Forgot something ? Continue Shopping</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// --- MAIN STORE COMPONENT ---
const HOVER_IMAGE_PAUSE_MS = 1400;

export default function NabiStore({ initialView = "list", initialProductId = null, onInitialProductOpened }) {
  const { globalCart, setGlobalCart, addToCart, removeFromCart, updateQty, setIsCartOpen, globalPincode, setGlobalPincode } = useOutletContext();
  const navigate = useNavigate();
  const [view, setView] = useState(initialView);
  const [category, setCategory] = useState("all");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [searchQuery, setSearchQuery] = useState(""); // Search State
  const [hoveredProductId, setHoveredProductId] = useState(null);
  const [hoverImageIndex, setHoverImageIndex] = useState(0);
  const [pincodeLocation, setPincodeLocation] = useState("");
  const [searchLocationInput, setSearchLocationInput] = useState(globalPincode || "");
  const [locationOptions, setLocationOptions] = useState([]);
  const [selectedCoords, setSelectedCoords] = useState(null);
  const [isStoreMapOpen, setIsStoreMapOpen] = useState(false);

  useEffect(() => { setView(initialView); }, [initialView]);

  useEffect(() => {
    // Whenever global pincode is updated from the map, update the input field
    if (globalPincode) setSearchLocationInput(globalPincode);
  }, [globalPincode]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (searchLocationInput.length > 2 && searchLocationInput !== globalPincode) {
        axios.get(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(searchLocationInput)}&country=india&format=json`)
          .then(res => {
            if (res.data) setLocationOptions(res.data);
          })
          .catch(() => setLocationOptions([]));
      } else {
        setLocationOptions([]);
      }
    }, 600); // 600ms debounce
    return () => clearTimeout(timer);
  }, [searchLocationInput, globalPincode]);

  useEffect(() => {
    if (initialProductId != null) {
      const product = PRODUCTS.find(p => p.id === initialProductId);
      if (product) {
        setSelectedProduct(product);
        setView("detail");
      }
      onInitialProductOpened?.();
    }
  }, [initialProductId]);

  useEffect(() => {
    if (hoveredProductId == null) return;
    const product = PRODUCTS.find(p => p.id === hoveredProductId);
    if (!product?.images || product.images.length <= 1) return;
    const id = setInterval(() => {
      setHoverImageIndex((prev) => (prev + 1) % product.images.length);
    }, HOVER_IMAGE_PAUSE_MS);
    return () => clearInterval(id);
  }, [hoveredProductId]);

  // Filter Logic: Category AND Search Query
  const filteredProducts = PRODUCTS.filter(p => {
    const matchesCategory = category === "all" || p.category === category;
    const matchesSearch = p.name.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  if (view === "checkout") {
    return (
      <CheckoutView
        globalCart={globalCart}
        updateQty={updateQty}
        removeFromCart={removeFromCart}
        processPayment={processPayment}
        initialPincode={globalPincode}
        onBack={() => {
          setView("list");
          navigate("/store");
        }}
      />
    );
  }

  if (view === "detail" && selectedProduct) {
    return <ProductDetail product={selectedProduct} onBack={() => setView("list")} onAddToCart={addToCart} />;
  }

  return (
    <div className="ns-pageContainer">
      <div className="ns-storeLayout">
        <div className="ns-sidebar">
          {/* Search Input in Sidebar */}
          <div className="ns-searchContainer">
            <img src={ASSETS.icons.search} alt="search" style={{ width: '18px' }} />
            <input
              type="text"
              placeholder="Search products..."
              className="ns-searchInput"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>

          {/* Location Search Input in Sidebar */}
          <div className="ns-searchContainer" style={{ display: 'flex', alignItems: 'center' }}>
            <span style={{ fontSize: '18px', marginRight: '5px' }}>📍</span>
            <input
              type="text"
              placeholder="Enter Pincode, Area, or City"
              className="ns-searchInput"
              value={searchLocationInput}
              onChange={(e) => setSearchLocationInput(e.target.value)}
              style={{ flex: 1 }}
            />
            <button 
               onClick={() => {
                   setSelectedCoords(null); 
                   setIsStoreMapOpen(true);
               }}
               style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#003049', fontSize: '18px', padding: '0 5px', opacity: 0.8 }}
               title="Locate exactly on map"
            >
               🗺️
            </button>
          </div>
          {pincodeLocation && (
            <div style={{ fontSize: '12px', color: 'red', marginTop: '-10px', marginBottom: '15px', marginLeft: '10px' }}>
              {pincodeLocation}
            </div>
          )}

          {locationOptions.length > 0 && !isStoreMapOpen && (
            <ul style={{ listStyle: 'none', padding: 0, margin: '5px 0 15px 0', border: '1px solid #ddd', borderRadius: '4px', maxHeight: '180px', overflowY: 'auto', fontSize: '13px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
              {locationOptions.map((opt, idx) => (
                <li 
                  key={idx}
                  style={{ padding: '10px 12px', borderBottom: '1px solid #eee', cursor: 'pointer', backgroundColor: 'white', display: 'flex', alignItems: 'center', gap: '8px', color: '#333' }}
                  onClick={() => {
                    setSelectedCoords({ lat: parseFloat(opt.lat), lon: parseFloat(opt.lon) });
                    setLocationOptions([]);
                    setIsStoreMapOpen(true);
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f8f9fa'}
                  onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                >
                  <span style={{ fontSize: '14px', color: '#888' }}>📌</span>
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                     <span style={{ fontWeight: 'bold' }}>{opt.display_name.split(',')[0]}</span>
                     <span style={{ fontSize: '11px', color: '#777' }}>{opt.display_name.split(',').slice(1).join(',')}</span>
                  </div>
                </li>
              ))}
            </ul>
          )}

          <LocationPickerModal 
            isOpen={isStoreMapOpen} 
            onClose={() => setIsStoreMapOpen(false)} 
            initialPincode={selectedCoords || globalPincode}
            initialArea={null}
            onLocationSelected={(loc) => {
              if (loc.pincode && loc.pincode.length === 6) {
                 setGlobalPincode(loc.pincode);
                 setSearchLocationInput(`${loc.city || loc.address}, ${loc.pincode}`);
              }
            }} 
          />

          <h3 style={{ marginBottom: '20px', marginTop: '30px' }}>Browse by</h3>
          <ul className="ns-catList">
            <li onClick={() => setCategory("all")} className={category === "all" ? "ns-activeCat" : ""}>All Products</li>
            <li onClick={() => setCategory("apparel")} className={category === "apparel" ? "ns-activeCat" : ""}>Nabi Apparel</li>
            <li onClick={() => setCategory("bookmarks")} className={category === "bookmarks" ? "ns-activeCat" : ""}>Nabi Bookmarks</li>
            <li onClick={() => setCategory("journaling")} className={category === "journaling" ? "ns-activeCat" : ""}>Nabi Journaling</li>
            
          </ul>
        </div>

        <div style={{ flex: 1 }}>
          <div className="ns-banner" style={{ backgroundImage: `url('${ASSETS.hero}')` }}></div>
          <h2 className="ns-catHeading">
            {category === "all" ? "All Products" : category.charAt(0).toUpperCase() + category.slice(1)}
          </h2>

          {filteredProducts.length === 0 ? (
            <p style={{ color: '#777', fontStyle: 'italic' }}>No products found.</p>
          ) : (
            <div className="ns-grid">
              {filteredProducts.map(p => {
                const images = p.images || [p.image];
                const isHovered = hoveredProductId === p.id;
                const displayImg = isHovered && images.length > 1
                  ? images[hoverImageIndex % images.length]
                  : p.image;
                return (
                  <div
                    key={p.id}
                    className="ns-productCard"
                    onClick={() => { setSelectedProduct(p); setView("detail"); }}
                    onMouseEnter={() => { setHoveredProductId(p.id); setHoverImageIndex(0); }}
                    onMouseLeave={() => setHoveredProductId(null)}
                  >
                    <div className="ns-imgWrapper">
                      <img
                        src={displayImg}
                        alt={p.name}
                        className="ns-prodImg"
                        style={{
                          transform: isHovered ? 'scale(1.06)' : 'scale(1)',
                          transition: 'transform 0.4s ease'
                        }}
                      />
                      {p.status === "Out of stock" && <div className="ns-outStockBadge">Out of stock</div>}
                    </div>
                    <h3 className="ns-prodTitle">{p.name}</h3>
                    <p className="ns-prodPrice">₹{p.price.toFixed(2)}</p>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
    // <div className="ns-emptyStoreContainer">
    //   <div className="ns-emptyMessage">
    //     Coming Soon...
    //   </div>
    // </div>
  );
}

